// import { useEffect, useState } from "react";
// import Zoom from "react-reveal/Zoom";
import { Link } from "react-router-dom";

const PlatformSolutionBox = ({ items }) => {
  return (
    <div
      className={`flex justify-center sm:items-center gap-[5rem] mx-[1rem] lg:gap-[4rem] md:gap-[4rem] xl:w-[70rem] lg:w-[60rem] md:w-[40rem] w-[16rem] mt-10 flex-wrap pt-[3rem] cursor-pointer  ${
        items.length > 6
          ? "max-w-[70rem]"
          : items.length === 6
          ? "max-w-[50rem]"
          : "max-w-[40rem]"
      }`}
    >
      {items.map((item, index) => (
        // <Zoom delay={delay} key={index}>
          <div key={index}>
            <div className="hidden"></div>
            <Link to={item.link}>
              <div className="flex flex-col justify-center items-center text-center transition-all duration-500 mt-[-2rem]">
                  <img
                    src={item.img}
                    alt=""
                    className={`h-[3rem] object-contain ${
                      item.name === "Overland Express" ||
                      item.name === "Sentiments Express"
                        ? "max-w-[5rem]"
                        : "max-w-[4rem]"
                    }`}
                  />
                  <p className="text-sm lg:w-[9rem] md:w-[4rem] sm:w-[5rem] w-[5rem] sm:mt-1 ">{item.name}</p>
                </div>
            </Link>
          </div>
        // </Zoom>
      ))}
      <div className="hidden"></div>
    </div>
  );
};

export default PlatformSolutionBox;
